// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_28-1";
export var movingGradient = "_28-4";
export var movingGradientBlock = "_28-2";
export var skeleton = "_28-0";
export var skeletonText = "_28-3";